import { BarChart3, Camera, Clapperboard, Globe2, LineChart, PenTool, Search } from 'lucide-react';

export const services = [
  { title: 'SEO Strategie', icon: Search, text: 'Technische Struktur, Content-Planung und skalierbare Sichtbarkeit fuer starke organische Rankings.' },
  { title: 'Produktbilder', icon: Camera, text: 'Conversion-starke Bildwelten fuer Shops, Marktplatzseiten und Performance-Kampagnen.' },
  { title: 'Produktvideos', icon: Clapperboard, text: 'Kurze, klare Videoformate fuer Ads, Produktseiten und Social Proof.' },
  { title: 'Content Produktion', icon: PenTool, text: 'Texte, Layouts und Medienablaeufe, die SEO und Verkauf zusammenbringen.' },
  { title: 'Mehrsprachigkeit', icon: Globe2, text: 'DE, EN, FR, ES, IT und AR inklusive hreflang und RTL-Vorbereitung.' },
  { title: 'Performance Tracking', icon: LineChart, text: 'Umami, GA4, Google Ads und Conversion Events sauber im Admin steuerbar.' },
  { title: 'Reporting', icon: BarChart3, text: 'Leads, Rankings, Kampagnen und Content-Status zentral verwalten.' }
];

export const stats = [
  { value: '400+', label: 'URLs migrationsfaehig' },
  { value: '6', label: 'Sprachen inkl. Arabisch' },
  { value: '100', label: 'SEO Zielwert' }
];

export const settingsGroups = [
  'Allgemein',
  'SEO',
  'Tracking',
  'Conversion Events',
  'CDN & Media',
  'Sentry',
  'Formulare',
  'Integrationen',
  'Rechtliches'
];

